// eslint-disable-next-line import/no-cycle
import LegacyColumn from './LegacyColumn.component';

export default LegacyColumn;
